export const phoneNumberTypes: { [key: string]: number } = {
    landline: 1,
    fax: 2,
    mobile: 3,
};

export const phoneNumberTypesDisplay: Record<number, PhoneNumberTypeEntry> = {
    [phoneNumberTypes.landline]: {
        label: 'Festnetz',
        icon: 'phone',
    },
    [phoneNumberTypes.fax]: {
        label: 'Fax',
        icon: 'local_printshop',
    },
    [phoneNumberTypes.mobile]: {
        label: 'Mobil',
        icon: 'stay_current_portrait',
    },
};